<template>
  <v-container fluid>
    <v-row >

      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col class="text-center">
            <p class="text-h5">Please login to your Reddit account to proceed</p>
            <p class="text--accent-1">We don't store any of your account details.  Your account is used to request data from Reddit's servers</p>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col class="text-center">
            <v-btn @click="loginOnClick" large>Click Here To Login</v-btn>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>

import {makeLoginId} from "@/util/helpers";
export default {
  props: {
    source: String,
  },
  methods: {
    loginOnClick: function () {
      let loginId = makeLoginId(10);
      let comingFrom = 'Home';
      if ('origin' in this.$route.query) {
        comingFrom = this.$route.query.origin
      }

      localStorage.setItem('loginDataId', loginId)
      window.location.href = this.getLoginUrl + `&state=${encodeURIComponent(JSON.stringify({loginId: loginId, origin: comingFrom}))}`;
    }
  },
  computed: {
    getLoginUrl() {
      return process.env.VUE_APP_REDDIT_LOGIN_URL;
    },
    getvarval() {
      return process.env.VUE_APP_REDDIT_REDIRECT_URL;
    }
  },
  mounted() {
    if ('autoredirect' in this.$route.query) {
      this.loginOnClick();
    }

  }
}
</script>

<style scoped>

</style>